// extracted by mini-css-extract-plugin
export default {"first-screen":"styles_first-screen__Fe-Da","container":"styles_container__xGUrn","logo":"styles_logo__XXkxZ"};